import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Flex } from '~/shared/components';
import { DisplayDateTitleProps } from '../types';

const DateBoxTextWrapper = styled(Flex)`
  color: inherit;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #4c5e72;
  pointer-events: none;
  overflow: visible;
`;

const DisplayDateResolutionTitle = ({ timeResolution }: DisplayDateTitleProps) => {
  const [dateTitle, setDateTitle] = useState('');

  useEffect(() => {
    if (timeResolution?.includes('Trending')) {
      setDateTitle(timeResolution);
    } else {
      const count = timeResolution?.split('-')[0];
      const key = timeResolution?.split('-')[1];
      const suffix = Number(count) > 1 ? 's' : '';
      setDateTitle(`${count} ${key}${suffix}`);
    }
  }, [timeResolution]);

  return <DateBoxTextWrapper>{dateTitle}:</DateBoxTextWrapper>;
};

export default DisplayDateResolutionTitle;
